export default __webpack_public_path__ + "static/media/frutiger-65bold.c333514c.ttf";